import * as P from 'plow-js';
import { handleActions } from 'redux-actions';
// feature loader
import {
  loaderRoutine,
} from './routines';
//////////////////////////////////////////////////

const initialState = {
  showLoader: false,
};

const showLoader = state => P.$set(
  'showLoader',
  true,
  state,
);

const hideLoader = state => P.$set(
  'showLoader',
  false,
  state,
);

export default handleActions({
  [loaderRoutine.SHOW]: showLoader,
  [loaderRoutine.HIDE]: hideLoader,
}, initialState);
